'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import { NavMarker } from 'react-rhumb';
import PresentationRecord from '../../records/PresentationRecord';
import PDFViewer from '../pdf/PDFViewer';
import getPresentationSlideImages from '../../selectors/getPresentationSlideImages';
import ViewPageDrawer from './ViewPageDrawer';
import { MAIN_CONTENT_ANCHOR } from '../../lib/constants';
import styled from 'styled-components';
const StyledContentAnchor = styled.div.withConfig({
  displayName: "ViewContent__StyledContentAnchor",
  componentId: "sc-1vzbimb-0"
})(["position:absolute;left:-10000px;top:auto;width:1px;height:1px;overflow:hidden;"]);

const ViewContent = ({
  file,
  presentation,
  pageDrawerOpen
}) => {
  if (file === null) {
    return null;
  }

  return /*#__PURE__*/_jsxs("div", {
    className: "view-content",
    "data-test-id": "view-content",
    children: [/*#__PURE__*/_jsx(NavMarker, {
      name: "PREVIEW_LOAD"
    }), /*#__PURE__*/_jsx(StyledContentAnchor, {
      "aria-label": presentation.get('name'),
      tabIndex: 0,
      id: MAIN_CONTENT_ANCHOR
    }), /*#__PURE__*/_jsx(PDFViewer, {
      file: file,
      presentationName: presentation.get('name'),
      imagePlaceholders: getPresentationSlideImages(presentation),
      branding: presentation.brandingMetadata
    }), /*#__PURE__*/_jsx(ViewPageDrawer, {
      open: pageDrawerOpen,
      presentation: presentation
    })]
  });
};

ViewContent.propTypes = {
  file: PropTypes.string,
  presentation: PropTypes.instanceOf(PresentationRecord).isRequired,
  pageDrawerOpen: PropTypes.bool.isRequired
};
export default ViewContent;